import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab/hooks';
import React from 'react';
import { EHarvestingView } from '../constants';
import HarvestCrystal from '../Crystal/HarvestCrystal';
import SelectSynchrotron from '../Synchrotron/SelectSynchrotron';
import { Cryoprotectant, Soaking } from '../protectantAgents';
import { useCrystalStates } from '../Crystal/hooks';
import SelectCryo from '../selectAgents/selectCryo';
import SelectSoaking from '../selectAgents/selectSoaking';
import '../Crystal/style.scss';

const tabComponents: ITabItem[] = [
  {
    title: 'Crystal',
    eventKey: 'Crystal',
    content: <HarvestCrystal />,
    contentClassName: 'h-[100%]',
  },
  {
    title: 'Cryoprotectant',
    eventKey: 'Cryoprotectant',
    content: <Cryoprotectant />,
  },
  {
    title: 'Soaking',
    eventKey: 'Soaking',
    content: <Soaking />,
  },
];
const HarvestingTabs = () => {
  const { harvestingContentView } = useCrystalStates();
  return (
    <>
      <div
        id="exp-harvestingtabs-container"
        className="h-[100%]"
        style={{
          display: `${
            harvestingContentView === EHarvestingView.HARVESTING ? 'block' : 'none'
          }`,
        }}
      >
        <RMTabs
          tabItems={tabComponents}
          defaultActiveKey={'Crystal'}
          id={'exp-harvestingtabs-crystaltabs'}
          className="h-[4.9%] mb-3"
        />
      </div>
      {harvestingContentView === EHarvestingView.SELECTTRIP ? (
        <div id="exp-harvestingtabs-selecttrip">
          <SelectSynchrotron id="exp-harvestingtabs-selectsynchrotron" />
        </div>
      ) : null}
      <div
        id="exp-harvestingtabs-selectcryo"
        style={{
          display: `${
            harvestingContentView === EHarvestingView.SELECTCRYO ? 'block' : 'none'
          }`,
        }}
      >
        <SelectCryo />
      </div>
      <div
        id="exp-harvestingtabs-selectsoaking"
        style={{
          display: `${
            harvestingContentView === EHarvestingView.SELECTSOAKING ? 'block' : 'none'
          }`,
        }}
      >
        <SelectSoaking />
      </div>
    </>
  );
};
export default HarvestingTabs;
